import React, { useContext, useEffect, useRef } from 'react';
import sounds from '@monorepo/shared/src/transformers/genericSounds';
import useActivityAudio from '@monorepo/shared/src/hooks/use-activity-audio';
import { ActivityContext } from 'state/providers/ActivityProvider';
import GWhoDndRound from './components/GWhoDndRound';
import { formatSounds } from '@monorepo/shared/src/util/sound-format-util';

const GuessWho: React.FC = () => {
  const [{ currentSound }, { loadAudioAssets, stopSound }] = useActivityAudio();
  const [state, { loadNextRound }] = useContext(ActivityContext);

  const handleOnRoundSuccess = () => {
    if (!state.isLastRound) {
      const round = state.currentRound.round + 1;
      const data = state.activity.rounds[state.currentRound.round];
      loadNextRound(round, data);
      return;
    }
  };

  const soundRef = useRef(currentSound);

  useEffect(() => {
    soundRef.current = currentSound;
  }, [currentSound]);

  useEffect(() => {
    return () => {
      if (soundRef.current) {
        soundRef.current.stop();
        stopSound(); // updates state
      }
    };
  }, []);
  useEffect(() => {
    const summary = state?.activity?.summary;
    const rounds = state?.activity?.rounds;
    if (summary && rounds) {
      const roundSounds = rounds.map(({ affirmation, answer, question, tiles }) => {
        const tileSounds = tiles.map((t) => t.audio);
        return [affirmation, answer, question, ...tileSounds];
      });
      const formattedSounds = formatSounds([summary, ...roundSounds.flat()].filter((x) => x));
      loadAudioAssets([sounds.BOINK, ...formattedSounds]);
    }
  }, [state?.activity]);

  return (
    <>{state?.currentRound?.round && <GWhoDndRound onRoundSuccess={handleOnRoundSuccess} />}</>
  );
};

export default GuessWho;
